export class FileDashboardData {
    isErrorDashboard: boolean;
    selectedDashboardItem: any;
    isRecalled: boolean;
    isReadUnreadFailed: boolean
}